import { Injectable } from '@angular/core';
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FirebaseNotificationService {

  constructor() { }

  requestPermission() {
    try {
      const app = initializeApp(environment.firebaseConfig);
      const messaging = getMessaging(app);

      Notification.requestPermission().then((permission) => {
        if (permission === 'granted') {
          console.log('Notification permission granted.');
          return getToken(messaging, { vapidKey: environment.vapidKey });
        } else {
          console.log('Unable to get permission to notify.');
          return null;
        }
      }).then((token) => {
        if (token) {
          console.log('FCM Token:', token);
          localStorage.setItem('fcmToken', token);
          const jwtToken = sessionStorage.getItem('jwtToken') || localStorage.getItem('jwtToken');
          if (jwtToken) {
            fetch(`${environment.apiBaseUrl}/user/device-token`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`
              },
              body: JSON.stringify({ deviceToken: token })
            }).catch(console.error);
          }
        } else {
          console.log('No registration token available. Request permission to generate one.');
        }
      }).catch((err) => {
        console.log('An error occurred while retrieving token. ', err);
      });

      onMessage(messaging, (payload) => {
        console.log('Message received. ', payload);
        // TODO: Update the UI to include the received message
      });
    } catch (error) {
      console.error('Firebase initialization error', error);
    }
  }
}
